import { createContext, useContext } from 'react';

/*
  Команды и состояние оболочки «Основы» для экранов: то, что живёт в оболочке, а нужно странице, —
  например, «Найти · Ctrl+K» на «не найдено» открывает тот же поиск, что и клавиши, а вкладки приложения
  знают, что оно ещё открывается.
*/

/** Холодное открытие приложения (первое за сеанс, R42): докуда дошли шаги и что делать при сбое. */
export interface AppOpening {
  /** Сервис приложения: 'app:infra'. */
  service: string;
  /** Имя в винительном: «Открываем «Инфраструктуру»». */
  name: string;
  steps: readonly string[];
  /** Сколько шагов пройдено. */
  done: number;
  /** Встало на шаге done. */
  failed: boolean;
  /** «Повторить»: шаги идут дальше с того же места. */
  retry: () => void;
  /** «Назад»: туда, откуда пришли в приложение. */
  back: () => void;
}

export interface ShellCommands {
  openSearch: () => void;
  /** Идёт холодное открытие приложения; null — ничего не открывается. */
  opening: AppOpening | null;
  /** Непрочитанные уведомления — состояние оболочки: счётчик колокольчика и строка на главной. */
  unread: number;
}

export const ShellCommandsContext = createContext<ShellCommands>({
  openSearch: () => undefined,
  opening: null,
  unread: 4,
});

export function useShellCommands(): ShellCommands {
  return useContext(ShellCommandsContext);
}
